import React from "react";
import { FOOTER_CONTACTS } from "../data/contacts";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";
import { Icon } from "@iconify/react";

export const ContactList = () => {
	const contactList = [...FOOTER_CONTACTS];

	return (
		<div className="contact-section">
			{contactList?.map((contactData, i) => (
				<div key={i}>
					<ContactCard data={contactData} />
				</div>
			))}
		</div>
	);
};

export const ContactCard = ({ data }) => {
	const footerTexts = useTranslationsById({ mainSectionName: "footer" });
	const title =
		footerTexts.getText({
			id: data?.title?.translationId,
			defaultText: data?.title?.default || "N/A",
		}) || "N/A";
	const emails = Array.isArray(data?.emails) ? data?.emails : [];
	const contactNumbers = Array.isArray(data?.contactNumbers) ? data?.contactNumbers : [];
	const adresses = Array.isArray(data?.adresses) ? data?.adresses : [];

	return (
		<div className="contact-card">
			<h3 className="title body-base">
				<span>{title}</span>
			</h3>
			<div className="info">
				{contactNumbers.length > 0 ? (
					<div className="contact-card__row">
						<Icon icon="mdi:phone-outline" width="1.75rem" />
						<div className="contact-card__content">
							{contactNumbers?.map((contact, i) => (
								<p key={i}>{contact}</p>
							))}
						</div>
					</div>
				) : null}
				{emails?.map((email, i) => (
					<div key={i} className="contact-card__row">
						<Icon icon="mdi:at" width="1.75rem" />
						<div className="contact-card__content">
							{email?.website ? (
								<a
									className="info font-weight-bold default-link d-block focusable-secondary"
									href={email.website}
									target="_blank"
									rel="noopener noreferrer"
									aria-label={`${footerTexts.getText({
										id: "contact.aria.send_email",
										defaultText: "Enviar correo a",
									})} ${email?.contactName}`}
								>
									{email?.contactName}
								</a>
							) : email?.contactName ? (
								<p className="info font-weight-bold">{email?.contactName}</p>
							) : null}
							<a
								className="info font-weight-bold default-link focusable-secondary"
								href={`mailto:${email?.email}`}
								aria-label={`${footerTexts.getText({
									id: "contact.aria.send_email",
									defaultText: "Enviar correo a",
								})} ${email?.email}`}
							>
								{email?.email}
							</a>
						</div>
					</div>
				))}
				{adresses?.length > 0 ? (
					<div className="contact-card__address">
						{adresses?.map((adress, i) => (
							<p key={i} className="info font-weight-normal">
								{adress}
							</p>
						))}
					</div>
				) : null}
			</div>
		</div>
	);
};
